// extracted by mini-css-extract-plugin
export var text = "_4n-0";